<style>
.div-row {
  display: flex;
  justify-content: space-between;
}
.div-searchdate {
  font-weight: bold;
  cursor: pointer;
}
.span-right {
  text-align: right; /* Alinea el texto a la derecha dentro del span */
}

.container-rep-search {
  display: flex;
  justify-content: center;
  height: 100%;
  padding: 20px;
}

.centered-content-rep-search {
  padding: 20px;
  /*background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 8px;*/
  width: 100%; 
  max-width: 500px;
  box-sizing: border-box;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <!-- <b-card-header header-tag="header" class="p-1" role="tab">Reporte diario de operaciones</b-card-header> -->
      <b-card-body>
        <div class="container-rep-search">
          <div class="centered-content-rep-search">
            <div
              style="font-weight:bold; margin-bottom:20px;"
            >Seleccioná una de las opciones para realizar tus reportes de impuestos</div>
            <div>
              <div
                class="div-row div-searchdate"
                style="border: 1px solid #d6d4d4;"
                v-for="item in this.SearchDates"
                v-bind:key="item.ID"
                @click="showSearchAdvance(item.EntityID)"
              >
                <span>{{item.Name}}</span>
                <span class="span-right">></span>
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  components: {},
  data() {
    return {
      SearchDates: []
    };
  },
  methods: {
    showSearchAdvance(id) {
      let context = this;

      context.$router.push({
        name: "ReporteImpuestos",
        params: { SearchIDProp: id }
      });
    },
    InitializeSearchDates() {
      let context = this;

      axiosHelpers.axiosGet(
        "DailyOperationsReport/GetTaxesReportViewerIndex",
        {},
        context,
        function(data) {
          context.SearchDates = data.ResponseVM.SearchItems;
        }
      );
    }
  },
  beforeMount() {
    this.InitializeSearchDates();
  }
};
</script>